import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IaService } from '../api/ia.service';

export interface ChatMessage {
  text: string;
  isBot: boolean;
  timestamp: Date;
}

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  standalone: false,
})
export class ChatComponent implements OnInit {
  @Output() messageSent = new EventEmitter<string>();

  @ViewChild('messagesContainer') messagesContainer: ElementRef;

  isOpen = false;
  messageText = '';
  messages: ChatMessage[] = [];
  isLoading = false;

  constructor(private iaService: IaService) {}

  ngOnInit() {}

  toggleChat() {
    this.isOpen = !this.isOpen;
  }

  closeChat() {
    this.isOpen = false;
  }

  sendMessage() {
    const text = this.messageText.trim();
    if (!text || this.isLoading) {
      return;
    }

    this.messageText = '';

    this.messages.push({ text, isBot: false, timestamp: new Date() });
    this.messageSent.emit(text);
    this.scrollToBottom();

    this.isLoading = true;
    this.iaService.chat(text).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        const botText =
          response?.Resposta ||
          response?.resposta ||
          response?.Texto ||
          response?.texto ||
          (typeof response === 'string' ? response : JSON.stringify(response));
        this.addBotMessage(botText);
      },
      error: () => {
        this.isLoading = false;
        this.addBotMessage('Desculpe, ocorreu um erro. Tente novamente.');
      },
    });
  }

  addBotMessage(text: string) {
    this.messages.push({ text, isBot: true, timestamp: new Date() });
    setTimeout(() => this.scrollToBottom(), 80);
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  private scrollToBottom() {
    try {
      const el = this.messagesContainer?.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    } catch {}
  }
}
